
import { defineComponent } from "vue";

function defaultOptions() {
  return {
    contactUpdate: {
      askForEmail: false,
      askForPhone: false
    },
    imageReading: {
      enabled: false
    }
  };
}

export default defineComponent({
  name: "ai-agent-options-panel",
  props: {
    modelValue: {
      type: Object,
      default: () => defaultOptions()
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      selectedOption: "contactUpdate",
      options: defaultOptions(),
      optionItems: [
        { key: "contactUpdate", label: "Contact Update", disabled: false },
        { key: "imageReading", label: "Image Reading", disabled: false }
      ]
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      deep: true,
      handler(value) {
        this.options = this.normalizeOptions(value);
      }
    },
    options: {
      deep: true,
      handler(value) {
        this.$emit("update:modelValue", JSON.parse(JSON.stringify(value)));
      }
    }
  },
  methods: {
    normalizeOptions(input: any) {
      const base = defaultOptions();
      const source = input && typeof input === "object" ? input : {};
      const contactUpdate = source.contactUpdate || {};
      const imageReading = source.imageReading || {};
      return {
        contactUpdate: {
          askForEmail: Boolean(contactUpdate.askForEmail),
          askForPhone: Boolean(contactUpdate.askForPhone)
        },
        imageReading: {
          enabled: Boolean(imageReading.enabled)
        }
      };
    },
    selectOption(item: any) {
      if (item.disabled) return;
      this.selectedOption = item.key;
    }
  }
});
